// @ts-nocheck
import {
  Box,
  Card,
  Group,
  SimpleGrid,
  Stack,
  Text as MantineText,
  Title,
} from '@mantine/core';
import { Avatar, Badge, Divider, Text } from '../../../components/ui';

export default function TypographyPage() {
  return (
    <Stack gap="xl">
      <Box>
        <Text gradient gradientVariant="primary" size="xl" fw={700}>
          Typography
        </Text>
        <MantineText c="dimmed" size="sm">
          Gradient text, avatars, dividers, and typography components
        </MantineText>
      </Box>

      {/* Gradient Text Sizes */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Gradient Text Sizes</Title>

          <Text gradient gradientVariant="primary" size="3rem" fw={800}>
            Extra Large Heading
          </Text>
          <Text gradient gradientVariant="secondary" size="2rem" fw={700}>
            Large Heading
          </Text>
          <Text gradient gradientVariant="tertiary" size="1.5rem" fw={600}>
            Medium Heading
          </Text>
          <Text gradient gradientVariant="primary" size="lg" fw={500}>
            Regular Text with Gradient
          </Text>
          <Text gradient gradientVariant="secondary" size="sm">
            Small text with gradient effect
          </Text>
        </Stack>
      </Card>

      {/* Animated Gradient Text */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Animated Gradient Text</Title>

          <Text gradient gradientVariant="primary" size="2rem" fw={700} animate>
            Animated Primary Gradient
          </Text>
          <Text gradient gradientVariant="secondary" size="xl" fw={600} animate>
            Animated Secondary Gradient
          </Text>
          <Text gradient gradientVariant="success" size="lg" fw={500} animate>
            Animated Success Gradient
          </Text>
        </Stack>
      </Card>

      {/* All Gradient Variants */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Gradient Variants</Title>

          <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
            <Box>
              <Text gradient gradientVariant="primary" size="lg" fw={600}>
                Primary Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="secondary" size="lg" fw={600}>
                Secondary Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="tertiary" size="lg" fw={600}>
                Tertiary Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="success" size="lg" fw={600}>
                Success Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="warning" size="lg" fw={600}>
                Warning Gradient
              </Text>
            </Box>
            <Box>
              <Text gradient gradientVariant="danger" size="lg" fw={600}>
                Danger Gradient
              </Text>
            </Box>
          </SimpleGrid>
        </Stack>
      </Card>

      {/* Gradient Dividers */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="lg">
          <Title order={4}>Gradient Dividers</Title>

          <Box>
            <MantineText size="sm" mb="xs">
              Primary (2px)
            </MantineText>
            <Divider gradientVariant="primary" thickness={2} />
          </Box>

          <Box>
            <MantineText size="sm" mb="xs">
              Secondary (3px)
            </MantineText>
            <Divider gradientVariant="secondary" thickness={3} />
          </Box>

          <Box>
            <MantineText size="sm" mb="xs">
              Tertiary (4px)
            </MantineText>
            <Divider gradientVariant="tertiary" thickness={4} />
          </Box>

          <Box>
            <MantineText size="sm" mb="xs">
              Animated Divider
            </MantineText>
            <Divider gradientVariant="primary" thickness={3} animated />
          </Box>
        </Stack>
      </Card>

      {/* Gradient Badges */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Gradient Badges</Title>

          <Group gap="sm">
            <Badge gradientVariant="primary" size="lg">
              Primary
            </Badge>
            <Badge gradientVariant="secondary" size="lg">
              Secondary
            </Badge>
            <Badge gradientVariant="tertiary" size="lg">
              Tertiary
            </Badge>
          </Group>

          <Group gap="sm">
            <Badge gradientVariant="success" size="md">
              Success
            </Badge>
            <Badge gradientVariant="info" size="md">
              Info
            </Badge>
            <Badge gradientVariant="warning" size="md">
              Warning
            </Badge>
            <Badge gradientVariant="danger" size="md">
              Danger
            </Badge>
          </Group>

          <MantineText size="sm" fw={500} mt="sm">
            Outlined Badges
          </MantineText>
          <Group gap="sm">
            <Badge gradientVariant="primary" outlined>
              Primary
            </Badge>
            <Badge gradientVariant="secondary" outlined>
              Secondary
            </Badge>
            <Badge gradientVariant="success" outlined>
              Success
            </Badge>
          </Group>
        </Stack>
      </Card>

      {/* Gradient Avatars */}
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <Title order={4}>Gradient Avatars</Title>

          <Group gap="xl">
            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="primary"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png"
                size="lg"
              />
              <MantineText size="xs">Primary</MantineText>
            </Stack>

            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="secondary"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-2.png"
                size="lg"
              />
              <MantineText size="xs">Secondary</MantineText>
            </Stack>

            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="tertiary"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-3.png"
                size="lg"
              />
              <MantineText size="xs">Tertiary</MantineText>
            </Stack>

            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="success"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-4.png"
                size="lg"
                borderWidth={4}
              />
              <MantineText size="xs">Success (4px)</MantineText>
            </Stack>

            <Stack align="center" gap="xs">
              <Avatar
                gradientBorder
                gradientVariant="primary"
                src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-5.png"
                size="xl"
                animated
              />
              <MantineText size="xs">Animated</MantineText>
            </Stack>
          </Group>
        </Stack>
      </Card>
    </Stack>
  );
}
